import {
    NavParams
  } from 'ionic-angular/navigation/nav-params';
  import {
    Component,
    ViewChild,
    OnInit,
    Host,
    OnDestroy
  } from '@angular/core';
  import {
    DocumentCirculationService
  } from './../../../../../providers/document-circulation.service';
  import {
    RunningDocument,
    Provider,
    RunningDocumentInfo,
    LastDates,
    DateInterval
  } from '../../../model/index';
  import {
    Observable
  } from 'rxjs/Rx';
  import {
    Subscription
  } from 'rxjs/Subscription';
  import {
    FileUploader
  } from 'ng2-file-upload';
  import {
    Location
  } from '@angular/common';
  /*import {
    dns
  } from "../../../../../providers/global.config";*/
  import {
    Events
  } from 'ionic-angular/util/events';
import { ViewController } from 'ionic-angular/navigation/view-controller';
  
  
  @Component({
    templateUrl: 'doc-circ-form.html'
  })
  export class DocCircForm{
      all:any;
      data: RunningDocumentInfo;
      startdate:any;
      enddate:any;
      type:any;
      datedebut:any;
      datefin:any;
      insuranceProviders: Provider[] = [];
      otherProviders: Provider[] = [];
      showfournisseur:boolean=false;
      idProvider: number = 0;
      Provider:any;
      providerName:any;
    
      constructor(public navParams:NavParams,public viewCtrl:ViewController,private documentService:DocumentCirculationService){
          this.data=navParams.get('item');
          this.providerName=this.data.providerName;
          this.datedebut=(new Date(this.data.operationTime)).toISOString();
          this.datefin=(new Date(this.data.endTime)).toISOString();
             }
      ngOnInit(){
        this.documentService.getProviders("INSURANCE").subscribe(response => {
          this.insuranceProviders = response;
        });
        this.documentService.getProviders("OTHER").subscribe(response => {
          this.otherProviders = response;
        });
      }
      closeModal(){
        this.viewCtrl.dismiss(null);
      }
      update(){
        this.data.operationTime=(new Date(this.datedebut)).getTime();
        this.data.endTime=(new Date(this.datefin)).getTime();
        let data={insurance:this.data,idProvider:this.idProvider,providerName:this.providerName}
        this.viewCtrl.dismiss(data)
      }
      typefournisseur(type: any) {
        if (type == "0") {
          this.showfournisseur = true;
          this.providerName = "";
        }else{
        }
        this.insuranceProviders.forEach(fournisseur=>{
          if(fournisseur==type){
            this.idProvider=fournisseur.id;
          }
        })
        this.data.providerName=this.providerName;
      }
  }


// WEBPACK FOOTER //
// ./src/pages/gestion-park/documentcirculation/doc-circ-aff/doc-circ-form/doc-circ-form.ts